<template>
  <v-container grid-list-xl>
    <v-layout
      row
      wrap
    >
      <v-flex
        lg12
        sm12
        xs12
      >      
        <v-form
          ref="form"
          lazy-validation
          class="app-form"
          @submit.prevent="onSubmit"
        >
          <v-card
            class="app-card"
            elevation="0"
          >
            <v-card-title class="app-card-title">
              <h4 class="text">
                <span>{{ !isEditableRouter() ? 'Nova' : 'Editar' }} Funcionalidade</span>
              </h4>
            </v-card-title>
            <v-card-text class="app-card-content">
              <v-row>
                <v-col
                  :lg="6"
                  :md="6"
                  :sm="6"
                  class="pb-0"
                >
                  <v-text-field
                    v-model="form.name"
                    outlined
                    dense
                    label="Nome *"
                    placeholder="Digite o nome"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col
                  :lg="6"
                  :md="6"
                  :sm="6"
                  class="pb-0"
                >
                  <v-text-field
                    v-model="form.key"
                    outlined
                    dense
                    label="Key *"
                    placeholder="Digite a key"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col
                  :lg="12"
                  :md="12"
                  :sm="12"
                  class="pb-0"
                >
                  <v-autocomplete
                    v-model="form.profiles"
                    outlined
                    dense
                    chips
                    small-chips
                    label="Perfis *"
                    multiple
                    item-text="name"
                    return-object
                    :items="profiles"
                    :rules="[rules.required]"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions class="app-card-actions">
              <span class="app-form__warning">
                Atenção: Campos que possuem o
                <em>*</em> são obrigatórios
              </span>
              <v-spacer />
              <v-btn
                depressed
                outlined
                color="error"
                @click="$router.back()"
              >
                Voltar
              </v-btn>
              <v-btn
                depressed
                color="success"
                type="submit"
              >
                Salvar
              </v-btn>
            </v-card-actions>
            <section
              v-if="detail.isLoading"
              class="loading"
            >
              <v-progress-circular
                indeterminate
                color="success"
              />
              <span>Enviando informações ...</span>
            </section>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>  
  import { mapActions, mapState } from 'vuex';

  export default {
    data: () => ({      
      form: {
      },      
      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido'
      }
    }),
    
    computed: {
      ...mapState('funcionalidade', ['detail']),
      ...mapState('perfil', { 
        profiles: state => state.table.content,
        profilesPaginate: state => state.table.paginate,
      }),
    },
    
    mounted() {      
      this.fetchProfiles(); 
      this.initData();
    },
    
    destroyed() {
      this.clearResource();
      this.clearProfiles();
    },

    methods: {
      onSubmit() {
        const isValid = this.$refs.form.validate();

        if (isValid) {
          const { id, name, key, profiles } = this.form;
          const body = {     
            id,
            name, 
            key, 
            profile_ids: profiles.map(profile => profile.id) 
          };

          if (!this.isEditableRouter()) {
            this.create(body);
          } else {
            this.update(body);
          }
        }
      },

      async initData() {
        const {          
          params: { id }
        } = this.$route;        

        if (!this.isEditableRouter()) return;        
        
        await this.getFuncionalidade(id);
                
        this.form = { ...this.detail.data };        
      },

      isEditableRouter() {
        const { name } = this.$route;
        return name === 'dashboard-funcionalidades-editar';
      },

      fetchProfiles() {
        const params = {          
          input: {},
          inputPage: {
            page: 1,
            itemsPerPage: 1000,
            sort: 'id:asc',
          }        
        }

        this.setPaginateParams(params);
        this.searchProfiles();
      },


      ...mapActions('funcionalidade', { create: 'CREATE' }),
      ...mapActions('funcionalidade', { update: 'UPDATE' }),
      ...mapActions('funcionalidade', { getFuncionalidade: 'SHOW' }),
      ...mapActions('funcionalidade', { clearResource: 'CLEAR_DETAIL' }),
      ...mapActions('perfil', { searchProfiles: 'SEARCH' }),
      ...mapActions('perfil', { clearProfiles: 'CLEAR' }),
      ...mapActions('perfil', { setPaginateParams: 'CHANGE_PAGE' }),
    },
  };
</script>
